import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';

import { MatchDetailStateService } from '../../features/statistics/controller/match-detail-state.service';

import { MatchDetailHeaderComponent } from '../../features/statistics/view/match-detail-header/match-detail-header.component';
import { MatchPlayerStatsComponent } from '../../features/statistics/view/match-player-stats/match-player-stats.component';
import { MatchGoalChronologyComponent } from '../../features/statistics/view/match-goal-chronology/match-goal-chronology.component';
import { MatchEventsListComponent } from '../../features/statistics/view/match-events-list/match-events-list.component';

import {
  GoalChronologyDTO,
  MatchEventDetailsDTO,
  MatchInfoDTO,
  MatchPlayerStatsDetailsDTO
} from '@solverml/api';

/**
 * Página "Smart" (Contenedor) para la vista de detalle de un partido.
 * Orquesta todos los componentes "Dumb" y se comunica
 * con el "Cerebro" (MatchDetailStateService).
 */
@Component({
  selector: 'app-match-detail-page',
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    RouterLink,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatchDetailHeaderComponent,
    MatchPlayerStatsComponent,
    MatchGoalChronologyComponent,
    MatchEventsListComponent
  ],
  templateUrl: './match-detail-page.component.html',
  styleUrls: ['./match-detail-page.component.scss'],
  /**
   * Proveemos el StateService A NIVEL DE COMPONENTE.
   * El estado se crea al navegar aquí y se destruye al salir.
   */
  providers: [MatchDetailStateService]
})
export class MatchDetailPageComponent implements OnInit, OnDestroy {

  // Inyección de dependencias
  private state = inject(MatchDetailStateService);
  private route = inject(ActivatedRoute);

  // Observables públicos para el template (conectados al state)
  public isLoading$: Observable<boolean>;
  public matchInfo$: Observable<MatchInfoDTO | null>;
  public playerStats$: Observable<MatchPlayerStatsDetailsDTO[] | null>;
  public matchEvents$: Observable<MatchEventDetailsDTO[] | null>;
  public goalChronology$: Observable<GoalChronologyDTO | null>;

  constructor() {
    this.isLoading$ = this.state.isLoading$;
    this.matchInfo$ = this.state.matchInfo$;
    this.playerStats$ = this.state.playerStats$;
    this.matchEvents$ = this.state.matchEvents$;
    this.goalChronology$ = this.state.goalChronology$;
  }

  ngOnInit(): void {
    // Obtener el ID del partido de la ruta
    const matchId = this.route.snapshot.paramMap.get('id');

    // Si tenemos ID, cargar los datos
    if (matchId) {
      // Convertimos a número
      this.state.loadData(+matchId);
    } else {
      console.error("No match ID found in route");
      // TODO: Manejar error (navegar a 404 o statistics)
    }
  }

  ngOnDestroy(): void {
    // Resetear el estado al salir de la página
    this.state.resetState();
  }
}
